import * as R from "ramda";
import { createHandlers } from "redux-mvc";
import { NAMESPACE, TABS } from "./constants";

const iniState = {
  loading: false,
  activeTab: TABS.BASIC_DETAILS,
  sessionId: null,
  hasSubsessions: false,
  isSubsession: false,
  data: {}
};

const model = createHandlers({
  iniState,
  reducers: {
    init: R.identity,
    openSession: R.identity,
    setInitialData: (
      _,
      {
        payload: {
          venues,
          eventTags,
          languages,
          tracks,
          formats,
          levels,
          sessionId,
          sessionData,
          editing,
          hasSubsessions,
          isSubsession
        }
      }
    ) => {
      return {
        editing,
        sessionId,
        venues,
        eventTags,
        languages,
        tracks,
        formats,
        levels,
        data: sessionData,
        hasSubsessions,
        isSubsession
      };
    }
  },
  namespace: NAMESPACE
});

const { actions, getters } = model;

export { actions, getters };

export default model;
